export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    rokkaImg: {
      type: Object,
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
};
